<template>
   <div>
	   <!-- ======= Hero Section ======= -->
	   <section id="hero" class="hero d-flex align-items-center">
		  <div class="swiper-container">
			<el-carousel :interval="5000" arrow="always" height="887px">
			    <el-carousel-item v-for="item in img" :key="item.picId">
					<img :src="$global.baseURL +  item.picPath" style="height: 100%;width: 100%;"/>
			    </el-carousel-item>
			</el-carousel>
	     </div>
	   </section>
	   
	   <main id="main">
	   
	     <!-- ======= 产品中心 ======= -->
	     <section id="values" class="values">
	       <div class="container" data-aos="fade-up">
	         <header class="section-header">
	           <p>产品中心</p>
	         </header>
	         <div class="row">
	           <div class="col-lg-4 cur" v-for="item in product" @click="toProductDetail(item)">
	             <div class="box" data-aos="fade-up" data-aos-delay="200">
				   <el-image 
				   class="img-fluid"
				   	:src="$global.baseURL + item.productPicture" 
				   	alt="图片加载失败"
				   	lazy>
				   </el-image>
	               <h3>{{item.productName}}</h3>
	               <p>{{((item.productTitle).length) > 60 ? (item.productTitle).substring(0,60)+'...' : item.productTitle }}</p>
	             </div>
	           </div>
	         </div>
	       </div>
	     </section>
	   
	   
	     <!-- ======= 解决方案 ======= -->
	     <section id="services" class="services">
	       <div class="container" data-aos="fade-up">
	         <header class="section-header">
	           <p>解决方案</p>
	         </header>
	         <div class="row gy-4">
	           <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200" v-for="item in solution">
	             <div class="service-box blue">
	               <i class="ri-discuss-line icon"></i>
	               <h3>{{item.title}}</h3>
	               <p>{{((item.remark).length) > 60 ? (item.remark).substring(0,60)+'...' : item.remark }}</p>
	               <a href="javascript:void(0)" @click="toSolutionDetail(item)" class="read-more"><span>详细信息</span> <i class="bi bi-arrow-right"></i></a>
	             </div>
	           </div>
	         </div>
	       </div>
	     </section>
	   	
	   	
	   	<!-- ======= 新闻资讯 ======= -->
	   	<section id="recent-blog-posts" class="recent-blog-posts">
	   	  <div class="container" data-aos="fade-up">
	   	    <header class="section-header">
	   	      <p>新闻资讯</p>
	   	    </header>
	   	    <div class="row">
	   	      <div class="col-lg-4" v-for="item in news">
	   	        <div class="post-box">
	   	          <div class="post-img">
					  <el-image
					  class="img-fluid"
					  	:src="$global.baseURL + item.newsPictrue" 
					  	alt="图片加载失败"
					  	lazy>
					  </el-image>
				  </div>
	   	          <span class="post-date">{{item.createTime}}</span>
	   	          <h3 class="post-title">{{((item.newsTitle).length) > 30 ? (item.newsTitle).substring(0,30)+'...' : item.newsTitle }}</h3>
	   	          <a href="javascript:void(0)" @click="toNewsDetail(item)" class="readmore stretched-link mt-auto"><span>详细信息</span><i class="bi bi-arrow-right"></i></a>
	   	        </div>
	   	      </div>

	   	    </div>
	   	  </div>
	   	</section>
	   	
	     <!-- ======= 合作院校 ======= -->
	     <section id="team" class="team">
	       <div class="container" data-aos="fade-up">
	         <header class="section-header">
	           <p>合作院校</p>
	         </header>
	         <div class="row gy-4">
			   
			   <div v-for="item in stroie" @click="toStroieDetail()" class="cur col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="400">
			     <div class="member">
			       <div class="member-img">
					 <el-image
					 class="img-fluid"
					 	:src="$global.baseURL + item.cover" 
					 	alt="图片加载失败"
					 	lazy>
					 </el-image>
			       </div>
			       <div class="member-info">
			         <h4>{{item.title}}</h4>
			       </div>
			     </div>
			   </div>
	         </div>
	       </div>
	     </section><!-- End Team Section -->
	   
	     <!-- ======= 联系我们 ======= -->
	     <section id="contact" class="contact">
	       <div class="container" data-aos="fade-up">
	         <div class="row gy-4">
	           <div class="col-lg-6">
	             <div class="row gy-4">
	               <div class="col-md-6">
	                 <div class="info-box">
	                   <i class="bi bi-geo-alt"></i>
	                   <h3>地址</h3>
	                   <p>{{contact.address}}</p>
	                 </div>
	               </div>
	               <div class="col-md-6">
	                 <div class="info-box">
	                   <i class="bi bi-telephone"></i>
	                   <h3>电话</h3>
	                   <p>{{contact.phone1}}<br>{{contact.phone2}}</p>
	                 </div>
	               </div>
				   
				   <div class="col-lg-6">
				     <form action="forms/contact.php" method="post" class="php-email-form">
				       <div class="row gy-4">
							<h4>公众号</h4>
							<img :src="$global.baseURL + contact.weixinPic"/>
				       </div>
				     </form>
				   </div>
				   
	             </div>
	           </div>
	     	   
	           <div class="col-lg-6">
	             <form action="forms/contact.php" method="post" class="php-email-form">
	               <div class="row gy-4">
	     			<MapContainer></MapContainer>
	               </div>
	             </form>
	           </div>
	         </div>
	       </div>
	     </section>
	   </main>
   </div>
   
</template>

<script>
	import axios from 'axios'
	import {mapState} from 'vuex'
	import MapContainer from './mapContainer.vue'
	
	export default{
		name: 'Welcome',
		components:{
			MapContainer
		},
		computed:{
			...mapState({
				contact: state => state.contact
			})
		},
		data() {
			return {
				//新闻信息内容
				news: [],
				
				//产品信息内容
				product: [],
				
				//解决方案信息内容
				solution: [],
				
				//案例信息内容
				stroie: [],
				
				// 轮播图
				img: [],
			}
		},
		methods:{
			toProductDetail(item){
				const pro = encodeURIComponent(JSON.stringify(item));
				this.$router.push({
					path: "/productDetail",
					query: {pro}
				});
			},
			toSolutionDetail(item){
				const solution = encodeURIComponent(JSON.stringify(item));
				this.$router.push({
					path: "/solutionDetail",
					query: {solution}
				});
			},
			toNewsDetail(item){
				const news = encodeURIComponent(JSON.stringify(item));
				this.$router.push({
					path: "/newsDetail",
					query: {news}
				});
			},
			toStroieDetail(){
				this.$router.push('/stroie')
			},
			//获取轮播图图片信息
			async getImg(){
				try{
					const resp = await axios.get("/api/system/pic/listAll");
					this.img = [];
					this.img = JSON.parse(JSON.stringify(resp.data.rows));
				}catch(e){
					console.log(e);
				}
			},
			
			//获取新闻列表
			async getNews(){
				try{
					const resp = await axios.get("/api/system/news/listAll");
					this.news = [];
					this.news = JSON.parse(JSON.stringify(resp.data.rows));
					if(this.news.length > 3) this.news.length = 3;
				}catch(e){
					console.log(e);
				}
			},
			
			//获取产品列表
			async getProduct(){
				try{
					const resp = await axios.get("/api/system/product/listAll");
					this.product = [];
					this.product = JSON.parse(JSON.stringify(resp.data.rows));
					if(this.product.length > 3) this.product.length = 3;
				}catch(e){
					console.log(e);
				}
			},
			
			//获取解决方案列表
			async getSolution(){
				try{
					const resp = await axios.get("/api/system/solution/listAll");
					this.solution = [];
					this.solution = JSON.parse(JSON.stringify(resp.data.rows));
					if(this.solution.length > 3) this.solution.length = 3;
				}catch(e){
					console.log(e);
				}
			},
			
			//获取案例列表
			async getStroie(){
				try{
					const resp = await axios.get("/api/system/case/listAll");
					this.stroie = [];
					this.stroie = JSON.parse(JSON.stringify(resp.data.rows));
					if(this.stroie.length > 4) this.stroie.length = 4;
				}catch(e){
					console.log(e);
				}
			},
			
		},
		mounted() {
			this.getImg();
			this.getProduct();
			this.getNews();
			this.getStroie();
			this.getSolution();
		},
		
	}
</script>

<style scoped>
	  .swiper-container{
		  width: 100%;
	  }
	  .cur:hover{
		cursor: pointer;
	  }
	  
	  .img-fluid img{
	  	object-fit: cover;
	  }
	  .el-image_inner{
	  	object-fit: cover;
	  }
	  
</style>
